import { cva } from 'class-variance-authority';

export const inputWrapper = cva(['grid', 'grid-rows-1'], {
  variants: {
    size: {
      large: ['grid-cols-[60px_auto_60px]'],
      default: ['grid-cols-[48px_auto_48px]'],
      small: ['grid-cols-[36px_auto_36px]'],
    },
  },
  defaultVariants: {
    size: 'default',
  },
});
